var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"graph-container"},[_c('span',{staticClass:"center"}),_c('div',{ref:"myEchart",staticClass:"graph",staticStyle:{"height":"380px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }